import { render, staticRenderFns } from "./streetViewPanorama.vue?vue&type=template&id=ed35740a"
import script from "./streetViewPanorama.vue?vue&type=script&lang=js"
export * from "./streetViewPanorama.vue?vue&type=script&lang=js"
import style0 from "./streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed35740a')) {
      api.createRecord('ed35740a', component.options)
    } else {
      api.reload('ed35740a', component.options)
    }
    module.hot.accept("./streetViewPanorama.vue?vue&type=template&id=ed35740a", function () {
      api.rerender('ed35740a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue"
export default component.exports